<template>
  <div>

    <Spinner v-if="loading === true" />
    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button">
        <button
          id="deleteMultiple"
          type="button"
          class="btn btn-outline-primary mb-2 mr-1"
          @click="confirmDeleteText(deletedArry)"
        >
          Delete Selected Elements
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2"
          @click="navigateTo('create-project')"
        >
          Create
        </button>
      </div>
    </div>
    <basic-table
      v-if="loading === false"
      :columns="columns"
      :values="rows"
      :selected-page="'edit-project'"
      :actions-obj="actionsArray"
      @dynamicAction="handleActions($event)"
      @refresh="renderTable"
      @choosenObject="getEditedObject($event)"
      @deleteItems="removeItems($event)"
      @deletedMultipleIds="catchIds($event)"
    />
  </div>
</template>
<script>
import BasicTable from '../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import projectService from '../../../services/projectService'
import Spinner from '@/shared/loader/Spinner'

export default {
  components: {
    Spinner,
    Create,
    Edit,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      actionsArray: [],
      editedItem: '',
      columns: [
        {
          label: 'Project',
          field: 'name',
        },
        {
          label: 'Client',
          field: 'user.full_name',
        },
        {
          label: 'Type',
          field: 'projectType.name',
        },
        {
          label: 'Area',
          field: 'area.name',
        },
        {
          label: 'Status',
          field: 'projectStatus.name',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getProjects()
    // this.actionsArray = [{ title: 'Design Phases', icon: 'SettingsIcon' }, { title: 'Fit Out Phases', icon: 'SettingsIcon' }]
    this.actionsArray = [{ title: 'Contracts', icon: 'FileTextIcon' }, { title: 'Design Phases', icon: 'SettingsIcon' }]

  },

  methods: {
    getProjects(withLoading = true) {
      this.loading = true
      projectService.index().then(response => {
        this.rows = response.data.data
        this.loading = false
      })
    },
    navigateTo(path) {
      this.$router.push({ name: 'create-project' })
    },
    getEditedObject(obj) {
      this.editedItem = obj
      this.$router.push({ name: 'edit-project', params: { id: this.editedItem.id } })
    },
    catchIds(ids) {
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            projectService.delete(arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                });

              }
            }).catch(error => {
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
      }
    },
    renderTable() {
      this.getProjects()
      this.loading = false;

    },
    handleActions(itemObj) {
      console.log(itemObj.key)
      switch (itemObj.key) {
        case 'Design Phases':
          this.$router.push({ name: 'project-design-phases', params: { id: itemObj.id } })
          break
        case 'Contracts':
          this.$router.push({ name: 'project-contracts', params: { id: itemObj.id } })
          break
        case 'Fit Out Phases':
          console.log('Action Object *******>', itemObj)
          break
        default:
          console.log('Action Object *******>', itemObj)
      }
      // this.$router.push({ name: 'representatives', params: { id: itemId } })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
